export default "__VITE_ASSET__D_ij7Nd2__"